import { Context, ProtocolInstance, Token } from '@/api/spec.ts';
import { parseUnits } from 'viem';

const DEFAULT_TOKEN: Token = {
  name: 'USD',
  symbol: 'USD',
  display_precision: 2,
  decimals: 6,
  address: undefined,
  icon: undefined,
  id: undefined,
  ver: 0,
  usd_index: undefined,
};

export type Exchange = {
  contract: ProtocolInstance;
  token: Token;
  minDeposit: bigint;
  minWithdraw: bigint;
  minAccountOpen: bigint;
  maxEquity?: bigint;
};

export const mapExchange = (apiContext: Context): Exchange | undefined => {
  if (!apiContext?.instances?.length || !apiContext?.markets?.length) {
    return undefined;
  }
  const contract = apiContext.instances[0];
  const token = apiContext.tokens?.find((t) => t.id === contract.collateral_token_id) ?? DEFAULT_TOKEN;

  const defaultTenUnits = parseUnits('10', token.decimals);
  const defaultCent = token.decimals >= 2 ? parseUnits('0.01', token.decimals) : 0n;

  return {
    contract,
    token,
    minAccountOpen: contract.min_account_open_amount ? BigInt(contract.min_account_open_amount) : defaultTenUnits,
    minDeposit: contract.min_deposit_amount ? BigInt(contract.min_deposit_amount) : defaultTenUnits,
    minWithdraw: contract.min_withdraw_amount ? BigInt(contract.min_withdraw_amount) : defaultCent,
    maxEquity: contract.max_account_equity ? BigInt(contract.max_account_equity) : undefined,
  };
};
